import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PreinvoiceListComponent } from './preinvoice-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { PreinvoiceService } from './preinvoice.service';

@Component({
    selector: 'convfact-preinvoicedelete',
    templateUrl: './preinvoice-dialog-delete.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})
export class PreinvoiceDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<PreinvoiceListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public preinvoiceService: PreinvoiceService
    ) { }

    delete() {
        this.preinvoiceService.deleteData(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }
}